import { Component, Mixins, Watch } from 'vue-property-decorator';
import applicationStore from '@/store/modules/applications/applicationStore';
import APP_UTILITIES from '@/utilities/commonFunctions';
import { ScreenText } from '@/lang/ScreenText';
import MANAGE_FAMILY_CONST from '@/constants/ManageFamilyConst';
import DeviceWidthCheckerMixin from '@/mixins/deviceWidthChecker.mixin';
import AccountSettings from '@/mixins/accountSettings.mixin';
import emptyState from '@/commoncomponents/emptyState/emptyState.vue';
import DropdownListBx from '@/ui-components/dropdownListBx/DropdownList.vue';
import { IDropdownConfig } from '@/Model/model';
import APP_CONST from '@/constants/AppConst';
import { ApplicationSiteDetailList, FormattedSessionSchedule } from '@/Model/enrollment/types';
import { getInstallmentsWithMakeupOnFinalInstallment } from '@/services/checkout/cart/helpers';
import InviteLink from '@/commoncomponents/inviteLink/InviteLink.vue';
import BouncingPreloader from '@/commoncomponents/bouncingpreloadercomponent/BouncingPreloaderComponent.vue';
import commonEntry from '@/store/modules/commonEntry';

import { ScholarContactType } from '@/Model/user/types';

@Component({
  components: {
    BouncingPreloader,
    'emptyState': emptyState,
    'dropdown': DropdownListBx,
    'invite-link': InviteLink,
  }
})

export default class ScholarPrograms extends Mixins(DeviceWidthCheckerMixin, AccountSettings) {
  APP_UTILITIES = APP_UTILITIES;
  public tooltipIndex = -1;
  public tooltipText = '';
  public tootltipColumnName = '';
  public isTooltip = false;
  public styleObj: any = {};

  private objScreenText: ScreenText = new ScreenText();
  public invalidPhone: boolean = false;
  public arrivalDropdown: string = '';
  public dismissalDropdown: string = '';
  public pickupErrorType: string = '';
  public activeProgramsActive: boolean = true;
  public authorizedPickupsActive: boolean = true;
  public authPickupsLength: number = 0;
  public dropdownConfig: IDropdownConfig = MANAGE_FAMILY_CONST.DROPDOWN_CONFIG;
  public inputTypes: string[] = MANAGE_FAMILY_CONST.INPUTTYPES;
  public isBannerShow: boolean = false;
  public noOfErrors: any = [];
  public positionofError: number = 0;
  public disablePrevButton: boolean = false;
  public disableNextButton: boolean = false;
  public nextPreviousButtonCalled: boolean = false;
  public dropdownTypes: string[] = ['select', 'dropdown'];
  public outsideClick: boolean = false;
  public isRedBannerShown: boolean = false;
  public isAuthorisedDetailsPresent: boolean = false;
  public readonly ScholarContactType = ScholarContactType;

  @Watch('editAuthorizePickups', { deep: true })
  checkAuthorizePickups(scholar: any) {
    this.authPickupsLength = scholar.length;
  }

  @Watch('selectedScholar', { deep: true })
  checkCurrentScholarDetails(scholar: any) {
    if (scholar.authorisedPickups) {
      this.authPickupsLength = scholar.authorisedPickups.length;
    }
  }

  /* istanbul ignore next */
  get selectedScholar() {
    return applicationStore.selectedScholar;
  }

  /* istanbul ignore next */
  get programDetail() {
    return applicationStore.programDetail;
  }

  /* istanbul ignore next */
  get authorizedPickup() {
    const authPickup = applicationStore.selectedScholar.authorisedPickups;
    if (authPickup && authPickup.length > 5) {
      return authPickup.splice(0, 5);
    }
    return authPickup;
  }

  get designColor(): string {
    return commonEntry.accountDesignDetails.accentColor;
  }

  /* istanbul ignore next */
  get editSiteDetails() {
    return applicationStore.editSiteDetails;
  }

  /* istanbul ignore next */
  get editMode() {
    return applicationStore.isFormProgramEditModeActive;
  }

  get editGuardianDetails() {
    return applicationStore.guardianDetails;
  }

  get editEmergencyDetails() {
    return applicationStore.emergencyDetails;
  }

  /* istanbul ignore next */
  get editAuthorizePickups() {
    return applicationStore.authorizeDetails;
  }

  /* istanbul ignore next */
  get phoneTypes() {
    const phoneTypes = MANAGE_FAMILY_CONST.PhoneTypes;
    return phoneTypes;
  }

  /* istanbul ignore next */
  get plansValue() {
    const plansValue = MANAGE_FAMILY_CONST.PlansValue;
    return plansValue;
  }

  get authPickupContainError() {
    let error = false;
    for (let i = 0; i < this.editAuthorizePickups.length; i++) {
      if (this.editAuthorizePickups[i].status.value != 3) {
        error = (this.editAuthorizePickups[i].firstName.alphaCharError || this.editAuthorizePickups[i].firstName.mandatoryError || this.editAuthorizePickups[i].firstName.errorStatus
          ? true
          : this.editAuthorizePickups[i] && this.editAuthorizePickups[i].firstName && this.editAuthorizePickups[i].firstName.value && (this.editAuthorizePickups[i].firstName.value.length != 0 && this.editAuthorizePickups[i].firstName.duplicateErrorStatus)
            ? true
            : false)

          || (this.editAuthorizePickups[i].lastName.alphaCharError || this.editAuthorizePickups[i].lastName.mandatoryError || this.editAuthorizePickups[i].lastName.errorStatus
            ? true
            : this.editAuthorizePickups[i] && this.editAuthorizePickups[i].lastName && this.editAuthorizePickups[i].lastName.value && (this.editAuthorizePickups[i].lastName.value.length != 0 && this.editAuthorizePickups[i].lastName.duplicateErrorStatus)
              ? true
              : false)

          || (this.editAuthorizePickups[i].relation.errorStatus
            ? true
            : false)

          || ((this.getPhoneNumber(this.editAuthorizePickups[i].phone.value).length == 0 && this.editAuthorizePickups[i].phone.errorStatus)
            ? true
            : false)

          || (this.editAuthorizePickups[i].pickUpStartDate.pickUpStartDateErr || this.editAuthorizePickups[i].pickUpStartDate.dateCalculationErr
            ? true
            : false)

          || (this.editAuthorizePickups[i].pickUpEndDate.pickUpEndDateErr || this.editAuthorizePickups[i].pickUpEndDate.dateCalculationErr
            ? true
            : false);

        if (error == true) {
          break;
        }
      }

    }
    return error;
  }

  getBillingDisplayString(siteDetails: ApplicationSiteDetailList) {
    const { sessionPrice, sessionBillingCycle, billingCycleCount } = siteDetails;
    if (sessionPrice && sessionBillingCycle && billingCycleCount) {
      const intervalPayments = getInstallmentsWithMakeupOnFinalInstallment(sessionPrice, billingCycleCount)[0];
      const formattedIntervalPayments = APP_UTILITIES.currencyFmt.format(intervalPayments);
      const formattedSessionPrice = APP_UTILITIES.currencyFmt.format(sessionPrice);
      const cycleAbbreviation = APP_UTILITIES.billingEnumToTextAbreviation(sessionBillingCycle);
      return `${formattedSessionPrice} ${this.getScreenText('PRICE_RECURRING_TOTAL')} (${formattedIntervalPayments}/${cycleAbbreviation})`;
    }
    return '--';
  }

  get isProgramDetailsByScholarLoading() {
    return applicationStore.isProgramDetailsByScholarLoading;
  }

  get isLoadingGetAddedScholarData() {
    return applicationStore.isLoadingGetAddedScholarData;
  }

  get formattedSessionSchedules(): Record<number, FormattedSessionSchedule> {
    const map: Record<number, FormattedSessionSchedule> = {};
    for (const program of this.programDetail) {
      for (const sessionDetails of program.siteDetailList) {
        map[sessionDetails.siteId] = this.getFormattedSessionSchedule(sessionDetails);
      }
    }
    return map;
  }

  private getFormattedSessionSchedule(sessionDetails: ApplicationSiteDetailList): FormattedSessionSchedule {
    const startDate = APP_UTILITIES.formatShortDateFullYear(sessionDetails.startDateTime);
    const endDate = APP_UTILITIES.formatShortDateFullYear(sessionDetails.endDateTime);
    const dates = `${startDate} - ${endDate}`;

    // The `days` property should in theory never be falsy because it is required admin side when configuring a Session
    // However this was the existing implementation, so keeping it in here for now
    const days = sessionDetails.days
      ? sessionDetails.days
      : '--';

    let times;
    if (sessionDetails.isTimeAdded) {
      const startTime = APP_UTILITIES.format12HrTimeFromDateTime(sessionDetails.startDateTime);
      const endTime = APP_UTILITIES.format12HrTimeFromDateTime(sessionDetails.endDateTime);
      times = `${startTime} - ${endTime}`;
    }

    return { dates, days, times };
  }

  /* istanbul ignore next */
  public getScreenText(key: string): string {
    return this.objScreenText.getScreenText(key);
  }

  getIsDelete(editAuthorizePickups: any) {
    return editAuthorizePickups[0].firstName.value == '' && editAuthorizePickups[0].lastName.value == '' && editAuthorizePickups[0].relation.value == '' && editAuthorizePickups[0].phone.value == '' && editAuthorizePickups[0].phoneType.value == 'Select' && editAuthorizePickups[0].pickUpStartDate.value == '' && editAuthorizePickups[0].pickUpEndDate.value == '';
  }

  formatDate(date: string) {
    return date && APP_UTILITIES.formatShortDateFullYear(date);
  }

  /* istanbul ignore else */
  formatNumberdash(number: any) {
    const phoneCheck = number && APP_UTILITIES.formatPhoneNumberWithBracket(number);

    if (phoneCheck) {
      return number && APP_UTILITIES.formatPhoneNumberWithBracket(number);
    }
    return number;
  }

  addAuthorizedPickup() {
    this.authorizedPickupsActive = true;
    if (!this.editMode) {
      applicationStore.mutateEditProgramFormMode(true);
      if (this.authorizedPickup && this.authorizedPickup.length) {
        applicationStore.mutateNewAuthorize();
      }
    }
    else {
      applicationStore.mutateNewAuthorize();
    }
    APP_UTILITIES.segmentTrackEvent(APP_CONST.SEGMENT_EVENTS.SCHOLAR_PROGRAMS.addAuthorizedPickup);
  }

  deleteAuthorizedPickup(index: number, editAuthorizePickup: any) {
    if (editAuthorizePickup.guid.value != '') {
      this.editAuthorizePickups[index].status.value = 3;
      const deletedAuthorized = this.editAuthorizePickups[index];
      applicationStore.mutateDeletedForAuthorize(deletedAuthorized);
    }
    applicationStore.mutateNewAuthorize(index);
    APP_UTILITIES.segmentTrackEvent(APP_CONST.SEGMENT_EVENTS.SCHOLAR_PROGRAMS.deleteAuthorizedPickup);
  }

  getPhoneNumber(value: string) {
    const values = APP_UTILITIES.removeSpecialCharacters(value);
    return values;
  }

  openEditDropdown(index: number, type: string, details: string, programIndex?: any) {
    if (type == 'arrivalPlan') {
      this.arrivalDropdown = `${programIndex}-${index}-${type}`;
    }
    else if (type == 'dismissalPlan') {
      this.dismissalDropdown = `${programIndex}-${index}-${type}`;
    }
    else if (type == 'phoneType') {
      this.editAuthorizePickups[index].phoneType.dropStatus = true;
    }
  }

  selectList(index: number, type: string, details: string, list: string, programIndex?: number) {
    if (programIndex != null) {
      if (type == 'dismissalPlan') {
        this.editSiteDetails[programIndex][index].dismissalPlan.value = list;
        this.dismissalDropdown = '';
      }
      else if (type == 'arrivalPlan') {
        this.editSiteDetails[programIndex][index].arrivalPlan.value = list;
        this.arrivalDropdown = '';
      }
    }
    else if (details == 'authorize') {
      this.editAuthorizePickups[index][type].value = list;
      this.editAuthorizePickups[index][type].dropStatus = false;
    }
  }

  pickUpStartEndDateChanges(dateVal: string, event: any, index: number, type: string) {
    if (event.key == 'Backspace') {
      this.editAuthorizePickups[index][type].dateCalculationErr = false;
      if (type == 'pickUpStartDate') {
        this.editAuthorizePickups[index][type].pickUpStartDateErr = true;
      }
      else {
        this.editAuthorizePickups[index][type].pickUpEndDateErr = true;
      }
    }
    else {
      if (type == 'pickUpStartDate') {
        this.editAuthorizePickups[index][type].pickUpStartDateErr = false;
      }
      else {
        this.editAuthorizePickups[index][type].pickUpEndDateErr = false;
      }
    }
    if (dateVal.length > 0) {
      this.dateOnChange(event, index, type);
      if (dateVal.length == 10) {
        this.comparePickStartAndPickEndDate(index);
      }
    }
  }

  comparePickStartAndPickEndDate(index: number) {
    if (this.editAuthorizePickups[index].pickUpStartDate.value.length == 10 && this.editAuthorizePickups[index].pickUpEndDate.value.length == 10) {
      const pickUpDate = new Date(this.editAuthorizePickups[index].pickUpStartDate.value);
      const pickEndDate = new Date(this.editAuthorizePickups[index].pickUpEndDate.value);
      if (pickUpDate < pickEndDate) {
        this.editAuthorizePickups[index].pickUpStartDate.dateCalculationErr = false;
        this.editAuthorizePickups[index].pickUpEndDate.dateCalculationErr = false;
      }
      else {
        this.editAuthorizePickups[index].pickUpStartDate.dateCalculationErr = true;
        this.editAuthorizePickups[index].pickUpStartDate.pickUpEndDateErr = false;
        this.editAuthorizePickups[index].pickUpEndDate.dateCalculationErr = true;
      }
    }
  }

  dateOnChange(e: any, index: number, type: string) {
    const fieldType = `${type}${index}`;
    const dateElement: any = document.querySelector(`#${fieldType}`);
    let input = this.editAuthorizePickups[index][type].value;

    if (/\D\/$/.test(input)) {
      input = input.substr(0, input.length - 3);
    }

    const checkLength = input.split('/').map(function (v: any) {
      return v.replace(/\D/g, '');
    });

    if (checkLength.length < 3 && checkLength[checkLength.length - 1].length > 2) {
      input = [input.slice(0, input.length - 1) + '/', input.slice(input.length - 1)].join('');
    }

    const values = input.split('/').map(function (v: any) {
      return v.replace(/\D/g, '');
    });
    /* istanbul ignore else */
    if (values[0]) {
      values[0] = this.checkValue(values[0], 12, true);
    }
    /* istanbul ignore else */
    if (values[1]) {
      values[1] = this.checkValue(values[1], 31, false);
    }

    const output = values.map(function (v: any, i: any) {
      return v.length == 2 && i < 2
        ? v + '/'
        : v;
    });

    let dateFormat = output.join('').substr(0, 14);

    if (e.key == 'Backspace' && ((dateFormat.substr(dateFormat.length - 1) == '/') || (dateFormat.substr(dateFormat.length - 1) == ''))) {
      dateFormat = dateFormat.substr(0, dateFormat.length - 1);
    }

    dateElement.value = dateFormat;
    return dateFormat;
  }

  checkValue(str: string, max: number, month: boolean) {
    if (str.charAt(0) !== '0' || str == '00') {
      let num = parseInt(str);
      if (isNaN(num) || num <= 0 || num > max) {
        num = parseInt(num.toString().charAt(0));
      }
      if (month) {
        str = num > parseInt(max.toString().charAt(0)) && num.toString().length == 1
          ? '0' + num
          : num.toString();
      }
      else {
        str = num > parseInt(max.toString().charAt(0)) && num.toString().length == 1
          ? ''
          : num.toString();
        if (str == '') {
          str = 0 + num.toString();
        }
      }
    }
    return str;
  }
  onblurdate(e: any, index: number, type: string) {
    const input = typeof (e) == 'object'
      ? e.target.value
      : e;

    const values = input.split('/').map(function (v: any) {
      return v.replace(/\D/g, '');
    });

    if (values.length == 3) {
      let year: number;
      const month = parseInt(values[0]) - 1;
      const day = parseInt(values[1]);
      if (values[2].length !== 4 || (values[2].length == 4 && (parseInt(values[2]) < 1000))) {
        if (type == 'pickUpStartDate') {
          this.editAuthorizePickups[index].pickUpStartDate.pickUpStartDateErr = true;
        }
        else {
          this.editAuthorizePickups[index].pickUpEndDate.pickUpEndDateErr = true;
        }
        this.pickupErrorType = 'wrong year';

      }
      else {
        if (type == 'pickUpStartDate') {
          this.editAuthorizePickups[index].pickUpStartDate.pickUpStartDateErr = false;
        }
        else {
          this.editAuthorizePickups[index].pickUpEndDate.pickUpEndDateErr = false;
        }
        this.pickupErrorType = '';
        year = parseInt(values[2]);


        if (values[0].length == 2 && values[1].length == 2) {
          if (type == 'pickUpStartDate') {
            this.editAuthorizePickups[index].pickUpStartDate.pickUpStartDateErr = !this.isValidDate(year, month, day);
            this.pickupErrorType = this.editAuthorizePickups[index].pickUpStartDate.pickUpStartDateErr
              ? 'Invalid Date'
              : '';

          }
          else {
            this.editAuthorizePickups[index].pickUpEndDate.pickUpEndDateErr = !this.isValidDate(year, month, day);
            this.pickupErrorType = this.editAuthorizePickups[index].pickUpEndDate.pickUpEndDateErr
              ? 'Invalid Date'
              : '';
          }
        }
        else {
          if (type == 'pickUpStartDate') {
            this.editAuthorizePickups[index].pickUpStartDate.pickUpStartDateErr = true;
          }
          else {
            this.editAuthorizePickups[index].pickUpEndDate.pickUpEndErr = true;
          }
        }
      }

    }
    else {
      if (type == 'pickUpStartDate') {
        this.editAuthorizePickups[index].pickUpStartDate.pickUpStartDateErr = true;
      }
      else {
        this.editAuthorizePickups[index].pickUpEndDate.pickUpEndDateErr = true;
      }
    }
  }

  isValidDate(year: number, month: number, day: number) {
    const d = new Date(year, month, day);
    /* istanbul ignore else */
    if (d.getFullYear() == year && d.getMonth() == month && d.getDate() == day) {
      return true;
    }
    return false;
  }

  getID(type: string, index: number) {
    return `${type}${index}`;
  }

  onlyNumber($event: any) {
    const keyCode = ($event.keyCode
      ? $event.keyCode
      : $event.which);
    if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
      $event.preventDefault();
    }
  }

  validateRecord(dataDetails?: any, fields?: any, includeIndex?: boolean) {
    let duplicateErrorStatus: boolean = false;
    if (dataDetails) {
      dataDetails.forEach((data: any, currentIndex: number) => {
        const currentFirstName = data.firstName.value
          ? data.firstName.value.toLowerCase()
          : '';
        const currentLastName = data.lastName.value
          ? data.lastName.value.toLowerCase()
          : '';
        if (this.inputTypes.includes(fields.input)) {
          if (fields.firstName && fields.lastName && ((currentFirstName == fields.firstName) && (currentLastName == fields.lastName) && (!includeIndex || (includeIndex && currentIndex != fields.elemIndex)))) {
            if (!duplicateErrorStatus && data.status.value != 3) {
              duplicateErrorStatus = true;
            }
          }
        }
      });
    }
    return duplicateErrorStatus;
  }

  validateAllRecords(recordDetails: any, input: string, type: ScholarContactType) {

    let duplicateThirdErrorStatus: boolean = false;
    if (recordDetails) {
      recordDetails.forEach((userData: any, currentIndex: number) => {
        userData.firstName.duplicateErrorStatus = false;
        userData.lastName.duplicateErrorStatus = false;
        const guardFirstName = userData.firstName.value
          ? userData.firstName.value.toLowerCase()
          : '';
        const guardLastName = userData.lastName.value
          ? userData.lastName.value.toLowerCase()
          : '';
        duplicateThirdErrorStatus = this.validateRecord(this.editAuthorizePickups, { firstName: guardFirstName, lastName: guardLastName, input: input, elemIndex: currentIndex }, type == this.ScholarContactType.AUTHORIZED_PICKUP
          ? true
          : false);
        if (this.ScholarContactType.AUTHORIZED_PICKUP) {
          if (duplicateThirdErrorStatus) {
            userData.lastName.duplicateErrorMessage = APP_CONST.DUPLICATE_AUTHORIZED_RECORD;
          }
        }
        if ((duplicateThirdErrorStatus && (userData.status.value != 3))) {
          userData.firstName.duplicateErrorStatus = true;
          userData.lastName.duplicateErrorStatus = true;
        }
      });
    }
  }

  validationsCheck(input: string) {
    this.validateAllRecords(this.editAuthorizePickups, input, this.ScholarContactType.AUTHORIZED_PICKUP);
  }

  public scholarValidation(userObj: any, input: string, event: any, type?: string, index?: number) {
    const key = event.key;
    const name = userObj.value;
    if (type == this.ScholarContactType.AUTHORIZED_PICKUP && (index || index == 0) && this.editAuthorizePickups[index].firstName.value == '' && this.editAuthorizePickups[index].lastName.value == '' && (this.editAuthorizePickups[index].phone.value == '' || this.editAuthorizePickups[index].phone.value == '(')) {
      this.isAuthorisedDetailsPresent = false;
      this.editAuthorizePickups[index].firstName.errorStatus = false;
      this.editAuthorizePickups[index].lastName.errorStatus = false;
      this.editAuthorizePickups[index].phone.errorStatus = false;
    }
    else {
      this.isAuthorisedDetailsPresent = true;
    }
    if (this.isAuthorisedDetailsPresent) {
      if (userObj.value == '' || input == 'phoneNumber' && userObj.value == '(') {
        userObj.errorStatus = true;
      }
      else {
        userObj.errorStatus = false;
      }
    }
    if (input == 'firstName' || input == 'lastName' || input == 'phoneNumber') {
      for (let i = 0; i < name.length; i++) {
        const numberCheck = APP_UTILITIES.hasOnlyAlphabetDotSpace(name);
        if (!numberCheck && !input.includes('phoneNumber')) {
          userObj.alphaCharError = true;
          return;
        }
        userObj.alphaCharError = false;
      }
      if (key == 'Backspace') {
        userObj.alphaCharError = false;
      }
      this.validationsCheck(input);


    }

  }

  validateFormProgramAuthorize() {
    let isInvalid = false;
    this.editAuthorizePickups.forEach((authorizePickup: any) => {
      if (authorizePickup.firstName.value != '' && (authorizePickup.firstName.alphaCharError || authorizePickup.firstName.errorStatus)) {
        isInvalid = true;
      }
      else if (authorizePickup.lastName.value != '' && (authorizePickup.lastName.alphaCharError || authorizePickup.lastName.errorStatus)) {
        isInvalid = true;
      }
      else if (authorizePickup.phone.value != '' && (authorizePickup.phone.errorStatus)) {
        isInvalid = true;
      }
      else if (authorizePickup.pickUpStartDate.value != '' && (authorizePickup.pickUpStartDate.pickUpStartDateErr || authorizePickup.pickUpStartDate.dateCalculationErr || authorizePickup.pickUpStartDate.errorStatus)) {
        isInvalid = true;
      }
      else if (authorizePickup.pickUpEndDate.value != '' && (authorizePickup.pickUpEndDate.pickUpEndDateErr || authorizePickup.pickUpEndDate.dateCalculationErr || authorizePickup.pickUpEndDate.errorStatus)) {
        isInvalid = true;
      }
      if (authorizePickup.firstName.value == '' && (authorizePickup.lastName.value || authorizePickup.phone.value || authorizePickup.relation.value || authorizePickup.pickUpStartDate.value || authorizePickup.pickUpEndDate.value)) {
        authorizePickup.firstName.errorStatus = true;
        isInvalid = true;
      }
      if (authorizePickup.lastName.value == '' && (authorizePickup.firstName.value || authorizePickup.phone.value || authorizePickup.relation.value || authorizePickup.pickUpStartDate.value || authorizePickup.pickUpEndDate.value)) {
        authorizePickup.lastName.errorStatus = true;
        isInvalid = true;
      }
      if (authorizePickup.phone.value == '' && (authorizePickup.firstName.value || authorizePickup.lastName.value || authorizePickup.relation.value || authorizePickup.pickUpStartDate.value || authorizePickup.pickUpEndDate.value)) {
        authorizePickup.phone.errorStatus = true;
        isInvalid = true;
      }
    });
    this.validationsCheck('firstName');
    if (isInvalid || !this.validateRecord()) {
      setTimeout(() => {
        const inputdoc: any = document.querySelectorAll('.outline-red');
        this.noOfErrors = inputdoc;
        this.isBannerShow = true;
        this.isRedBannerShown = false;
        this.movetoFirstError();
      }, 300);
    }
    return isInvalid;
  }

  syncLinksActivation() {
    if (this.selectedScholar.authorisedPickups) {
      this.authPickupsLength = this.selectedScholar.authorisedPickups.length;
    }
  }

  mounted() {
    applicationStore.mutateEditFormMode(true);
    applicationStore.mutateEditFormMode(false);
    this.syncLinksActivation();
    APP_UTILITIES.segmentTrackEvent(APP_CONST.SEGMENT_EVENTS.SCHOLAR_PROGRAMS.viewedScholarPrograms);
  }

  destroyed() {
    applicationStore.mutateEditProgramFormMode(false);
    applicationStore.mutateDuplicateErrorResponse('');
  }

  toggleActivePrograms() {
    this.activeProgramsActive = !this.activeProgramsActive;
  }

  toggleAuthorizedPickups() {
    this.authorizedPickupsActive = !this.authorizedPickupsActive;
  }

  preLabel() {
    this.nextPreviousButtonCalled = true;
    this.disablePrevButton = false;
    this.disableNextButton = false;
    const oldNumberOferrors = this.noOfErrors && this.noOfErrors.length;
    this.noOfErrors = document.querySelectorAll('.outline-red')
      ? document.querySelectorAll('.outline-red')
      : '';

    let valuecheked: boolean = false;
    const focussedElement: any = document.getElementsByClassName('error-outlined-banner');
    for (let index = 0; index < this.noOfErrors.length; index++) {
      if (this.noOfErrors[index] == focussedElement[0]) {
        this.positionofError = index + 1;
        valuecheked = true;
      }
    }

    if ((oldNumberOferrors > this.noOfErrors.length) && (this.noOfErrors.length < this.positionofError)) {
      const differenceBtwErrors = oldNumberOferrors - this.noOfErrors.length;
      const currentPosition = this.positionofError - differenceBtwErrors;
      this.positionofError = currentPosition <= 0
        ? APP_CONST.ONE
        : currentPosition + 1;
    }

    this.positionofError = valuecheked
      ? this.positionofError
      : this.positionofError - 1;
    if (this.positionofError !== 0 && this.positionofError <= this.noOfErrors.length) {
      this.disablePrevButton = false;
      this.positionofError = valuecheked
        ? this.positionofError - 1
        : this.positionofError;
      this.navigateToLabel(this.noOfErrors[this.positionofError - 1], this.noOfErrors[this.positionofError]);
    }
    if (this.positionofError == 1) {
      this.disablePrevButton = true;
    }
  }

  nextLabel() {
    this.nextPreviousButtonCalled = true;
    this.disableNextButton = false;
    this.disablePrevButton = false;
    let valuecheked: boolean = false;
    this.noOfErrors = document.querySelectorAll('.outline-red')
      ? document.querySelectorAll('.outline-red')
      : '';
    const focussedElement: any = document.getElementsByClassName('error-outlined-banner');
    for (let index = 0; index < this.noOfErrors.length; index++) {
      if (this.noOfErrors[index] == focussedElement[0]) {
        this.positionofError = index + 1;
        valuecheked = true;
      }

    }
    if (this.positionofError - 1 <= this.noOfErrors.length - 1) {
      this.disableNextButton = false;
      this.navigateToLabel(this.noOfErrors[valuecheked
        ? this.positionofError
        : this.positionofError - 1],
      this.noOfErrors[valuecheked
        ? this.positionofError - 1
        : this.positionofError - 2]);
      this.positionofError = valuecheked
        ? this.positionofError + 1
        : this.positionofError;
    }
    if (this.positionofError == this.noOfErrors.length) {
      this.disableNextButton = true;
    }
  }

  movetoFirstError() {
    this.disableNextButton = false;
    this.disablePrevButton = true;
    const inputdoc: any = document.querySelectorAll('.outline-red');
    inputdoc.forEach((element: any) => {
      element.classList.remove('error-outlined-banner');
    });
    this.noOfErrors = document.querySelectorAll('.outline-red')
      ? document.querySelectorAll('.outline-red')
      : '';
    this.navigateToLabel(this.noOfErrors[0]);
    this.positionofError = APP_CONST.ONE;
    if (this.noOfErrors.length == APP_CONST.ONE) {
      this.disableNextButton = true;
    }
  }

  navigateToLabel(element: HTMLElement, lastelement?: HTMLElement) {
    if (element) {
      this.isRedBannerShown = true;
      element.classList.add('error-outlined-banner');
      if ((element && element.className == 'pickup outline-red error-outlined-banner')) {
        this.authorizedPickupsActive = true;
      }
      setTimeout(() => {
        element && element.focus();
      }, 100);

      window.scrollBy({
        top: document.documentElement.clientWidth > 992
          ? element.getBoundingClientRect().top - 210
          : document.documentElement.clientWidth > 830
            ? element.getBoundingClientRect().top - 230
            : document.documentElement.clientWidth > 768
              ? element.getBoundingClientRect().top - 260
              : document.documentElement.clientWidth > 580
                ? element.getBoundingClientRect().top - 260
                : document.documentElement.clientWidth > 480
                  ? element.getBoundingClientRect().top - 260
                  : document.documentElement.clientWidth > 435
                    ? element.getBoundingClientRect().top - 260
                    : document.documentElement.clientWidth > 380
                      ? element.getBoundingClientRect().top - 270
                      : element.getBoundingClientRect().top - 290,
        behavior: 'smooth'
      });
    }
    if (lastelement) {
      lastelement.classList.remove('error-outlined-banner');
    }
  }

  updateErrorCount(nextPreviousButtonCalled: boolean, event: any) {
    if (event && event.srcElement.className != 'accordion__header') {
      setTimeout(() => {
        if (!nextPreviousButtonCalled && this.isBannerShow) {
          this.outsideClick = false;
          this.disableNextButton = false;
          this.disablePrevButton = false;
          const oldNumberOferrors = this.noOfErrors && this.noOfErrors.length;
          this.noOfErrors = document.querySelectorAll('.outline-red')
            ? document.querySelectorAll('.outline-red')
            : '';
          const focussedElement: any = document.getElementsByClassName('error-outlined-banner')
            ? document.getElementsByClassName('error-outlined-banner')
            : '';
          const activeElement: any = document.activeElement;
          if (focussedElement[0] && focussedElement[0] != activeElement) {
            focussedElement[0].classList.remove('error-outlined-banner');
          }
          if (activeElement && activeElement != document.body && (Object.entries(this.noOfErrors).find(x => x[1] == activeElement) || Object.entries(this.noOfErrors).find(x => x[1] == activeElement.parentElement.parentElement.previousSibling))) {
            if (activeElement.type == 'text') {
              activeElement.classList.add('error-outlined-banner');
              activeElement && activeElement.focus();
              window.scrollBy({
                top: document.documentElement.clientWidth > 992
                  ? activeElement.getBoundingClientRect().top - 210
                  : document.documentElement.clientWidth > 830
                    ? activeElement.getBoundingClientRect().top - 230
                    : document.documentElement.clientWidth > 768
                      ? activeElement.getBoundingClientRect().top - 260
                      : document.documentElement.clientWidth > 580
                        ? activeElement.getBoundingClientRect().top - 260
                        : document.documentElement.clientWidth > 480
                          ? activeElement.getBoundingClientRect().top - 260
                          : document.documentElement.clientWidth > 435
                            ? activeElement.getBoundingClientRect().top - 260
                            : document.documentElement.clientWidth > 380
                              ? activeElement.getBoundingClientRect().top - 270
                              : activeElement.getBoundingClientRect().top - 290,
                behavior: 'smooth'
              });
            }
            else {
              this.outsideClick = true;
            }
          }
          else {
            this.outsideClick = true;
          }

          for (let index = 0; index < this.noOfErrors.length; index++) {
            if (this.noOfErrors[index] == focussedElement[0]) {
              this.positionofError = index + 1;
            }
          }

          if (this.outsideClick && activeElement.type != 'text') {
            if ((oldNumberOferrors > this.noOfErrors.length) && (this.noOfErrors.length < this.positionofError)) {
              const differenceBtwErrors = oldNumberOferrors - this.noOfErrors.length;
              const currentPosition = this.positionofError - differenceBtwErrors;
              this.positionofError = currentPosition <= 0
                ? APP_CONST.ONE
                : currentPosition + 1;
            }
            const element: any = this.noOfErrors[this.positionofError - 1];
            const lastelement: any = this.noOfErrors[this.positionofError - 2];
            if (element) {
              this.isRedBannerShown = true;
              element.classList.add('error-outlined-banner');
              if ((element && element.className == 'pickup outline-red error-outlined-banner')) {
                this.authorizedPickupsActive = true;
              }
              setTimeout(() => {
                element && element.focus();
              }, 100);
              window.scrollBy({
                top: document.documentElement.clientWidth > 992
                  ? element.getBoundingClientRect().top - 210
                  : document.documentElement.clientWidth > 830
                    ? element.getBoundingClientRect().top - 230
                    : document.documentElement.clientWidth > 768
                      ? element.getBoundingClientRect().top - 260
                      : document.documentElement.clientWidth > 580
                        ? element.getBoundingClientRect().top - 260
                        : document.documentElement.clientWidth > 480
                          ? element.getBoundingClientRect().top - 260
                          : document.documentElement.clientWidth > 435
                            ? element.getBoundingClientRect().top - 260
                            : document.documentElement.clientWidth > 380
                              ? element.getBoundingClientRect().top - 270
                              : element.getBoundingClientRect().top - 290,
                behavior: 'smooth'
              });

              if (lastelement) {
                lastelement.classList.remove('error-outlined-banner');
              }
            }
            else if (!element && lastelement) {
              this.isRedBannerShown = true;
              lastelement && lastelement.classList.add('error-outlined-banner');
              lastelement && lastelement.focus();
              window.scrollBy({
                top: document.documentElement.clientWidth > 992
                  ? lastelement.getBoundingClientRect().top - 210
                  : document.documentElement.clientWidth > 830
                    ? lastelement.getBoundingClientRect().top - 230
                    : document.documentElement.clientWidth > 768
                      ? lastelement.getBoundingClientRect().top - 260
                      : document.documentElement.clientWidth > 580
                        ? lastelement.getBoundingClientRect().top - 260
                        : document.documentElement.clientWidth > 480
                          ? lastelement.getBoundingClientRect().top - 260
                          : document.documentElement.clientWidth > 435
                            ? lastelement.getBoundingClientRect().top - 260
                            : document.documentElement.clientWidth > 380
                              ? lastelement.getBoundingClientRect().top - 270
                              : lastelement.getBoundingClientRect().top - 290,
                behavior: 'smooth'
              });
              this.positionofError = this.positionofError - 1;
            }

          }
          if (this.positionofError == this.noOfErrors.length) {
            this.disableNextButton = true;
          }
          if (this.positionofError == APP_CONST.ONE) {
            this.disablePrevButton = true;
          }
        }
        this.outsideClick = false;
        this.nextPreviousButtonCalled = false;
      }, 300);
    }
  }
}